import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { createAPI } from "services/api/api";

const api = createAPI();

function replaceInSlotWithOwned(data) {
  if (Array.isArray(data)) {
    data.forEach((item) => replaceInSlotWithOwned(item));
  } else if (typeof data === "object" && data !== null) {
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        if (key === "status" && data[key] === "In Slot") {
          data[key] = "Owned";
        } else if (typeof data[key] === "object") {
          replaceInSlotWithOwned(data[key]);
        }
      }
    }
  }
}

const useGetIdentityMatchesInventory = (item, setIsLoading, setMatches) => {

  const {pathname} = useLocation();

  const idParamName = pathname.includes('/marketplace') ? 'listing_id' : 'id_selected'

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    const requestParams = `${item.type.toLowerCase()}=${item.name}&${idParamName}=${item.id}`;

    api.get(`/me/identities_matches/params?${requestParams}`, { signal })
      .then((response) => {
        const processedData = JSON.parse(JSON.stringify(response.data));

        replaceInSlotWithOwned(processedData);

        setMatches(processedData);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Fetch aborted");
          setMatches([]);
          setIsLoading(true);
        } else {
          console.log(error);
          setMatches([]);
          setIsLoading(false);
        }
      });

    return () => {
      controller.abort();
      setMatches([]);
      setIsLoading(true);
    };
  }, [item, setIsLoading, setMatches]);
};

export default useGetIdentityMatchesInventory;
